import React, { FC } from 'react';
import { DateField, Text } from '@sitecore-jss/sitecore-jss-react';
import ctaTypes from '../../../../enums/CTA.enums';
import useFormatDate from '../../../../hooks/useFormatDate';
import useMediaQuery from '../../../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import CTA from '../../../@shared/cta';
import Media from '../media';
import { TRelatedNewsCardsProps } from '../../types/relatedNews.types';
import { RelatedNewsCardModel } from './models/relatedNewsCard.model';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import SocialMediaBar from '../../../@shared/socialMediaBar';

const RelatedNewsCard: FC<TRelatedNewsCardsProps> = ({ item, cardHeadingTitleTag, sitecoreContext, defaultCardImage, socialMediaBarProps }): JSX.Element => {
  const model = new RelatedNewsCardModel(item, sitecoreContext);
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-l']})`);
  const formattedDate = useFormatDate(model.newsDate?.value);
  const shareURL = new URL(model.ctaLink || '', sitecoreContext?.currentPageUrl as string || '').href;

  return (
    <article className='related-news-card'>
      {model?.tag?.value && (
        <div className={'related-news-card__tag'}>
          <Text field={model?.tag} tag={'div'} editable={false} className={'related-news-card__tag--text'} />
        </div>
      )}

      <Media
        desktopImage={model?.image}
        mobileImage={model?.mobileImage}
        isDesktop={isWide}
        useVideo={model?.showVideo}
        videoUrl={model?.video}
        defaultImage={defaultCardImage}
      />
      <div className="related-news-card__content--wrapper">
        <div className="related-news-card__content--body">
          <div className='related-news-card__content--date-share'>
            {model?.newsDate && (
              <DateField
                field={model.newsDate}
                tag="div"
                className="related-news-card__content--date"
                render={() => formattedDate}
                editable={false}
              />
            )}
            {socialMediaBarProps && (
              <SocialMediaBar
                {...socialMediaBarProps}
                listType='dropdown'
                useAnalytics={true}
                shareURL={shareURL}
                showInMobile={true}
              />
            )}
          </div>
          {model?.title && (
            <Text field={model?.title} tag={cardHeadingTitleTag} className="related-news-card__content--title" editable={false} />
          )}
          {model?.shortDescription && (
            <Text field={model?.shortDescription} tag={'div'} className="related-news-card__content--description" editable={false} />
          )}
        </div>
        {model?.ctaLink && (
          <CTA type={ctaTypes.primaryRed} href={model.ctaLink} extraClassName="related-news-card__content--button">
            <DictionaryTerm keyword="cnhi-readMore" />
          </CTA>
        )}
      </div>
    </article>
  );
};

export default RelatedNewsCard;
